var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.015,
    height: 15.911,
    viewBox: "0 0 11.015 15.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-pin",
    "data-name": "Icon ionic-ios-pin",
    d: "M13.383,3.375A5.323,5.323,0,0,0,7.875,8.489c0,3.978,5.508,10.8,5.508,10.8s5.508-6.82,5.508-10.8A5.323,5.323,0,0,0,13.383,3.375Zm0,7.3a1.794,1.794,0,1,1,1.794-1.794A1.794,1.794,0,0,1,13.383,10.677Z",
    transform: "translate(-7.875 -3.375)",
    fill: "#bf772f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.40000890819bf03c16bef3c6204e3098.svg";
export { ForwardRef as ReactComponent };